/** Адрес файла из `asset.asset_path` (хэш-путь): файлы раздаёт сервис под `/media`, за входом. */
export function mediaUrl(path: string | null | undefined): string {
  return path ? `/media/${path}` : "";
}

/** Превью ≤ 640 px для плиток сетки (мелкий оригинал сервис отдаёт как есть); полный файл — `mediaUrl`. */
export function thumbUrl(path: string | null | undefined): string {
  return path ? `/thumb/${path}` : "";
}

/** Число разрядами: 105030 → «105 030». */
export function num(value: number | null | undefined): string {
  return value === null || value === undefined ? "—" : value.toLocaleString("ru-RU");
}

/** Дата-время сервера (ISO без зоны, московское) → «03.10 14:05». */
export function when(value: string | null | undefined): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}
